var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"right-box"},[_c('div',{staticClass:"item"},[_c('img',{attrs:{"src":require("../assets/image/footer/h1.png"),"alt":""}})]),_c('div',{staticClass:"item"},[_c('img',{attrs:{"src":require("../assets/image/footer/h2.png"),"alt":""}})])])
}]

export { render, staticRenderFns }